export { postcssPhysicalToLogical } from './postcss';
export { stylisPhysicalToLogical } from './stylis';
//# sourceMappingURL=index.js.map